import { get, computed } from '@ember/object';
import moment from 'moment-timezone';

export const DEFAULT_TIMESTAMP_FORMAT = 'MMM D, YYYY [at] h:mm:ss a (z)';

export function formatWithTimezone(timestampKey: string, timezoneKey: string) {
  return computed(timestampKey, timezoneKey, function () {
    let timestamp: number = get(this, timestampKey);
    let timezone: string = get(this, timezoneKey);

    if (!timestamp || !timezone) {
      return null;
    }

    return moment.unix(timestamp).tz(timezone).format(DEFAULT_TIMESTAMP_FORMAT);
  });
}
